import styled from "styled-components";
import { Title } from '../title/Title';

export const Span = styled(Title)`
    margin-bottom: 30px;
    font-size: 20px;
`;

export const ButtonClose = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  transition: .4s;

  &&:hover {
    transform: scale(.95);
  }
`;
